document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector(".reviews-section");
  const rawData = section.getAttribute('data-slides');
  const slidesArray = JSON.parse(rawData);
  const slideData = slidesArray.flat();
  console.log(slideData);

  let currentSlideIndex = localStorage.getItem('currentSlideIndex')
    ? parseInt(localStorage.getItem('currentSlideIndex'))
    : 0;

  if (currentSlideIndex < 0 || currentSlideIndex >= slideData.length) {
    currentSlideIndex = 0;
  }

  const slideCount = 4;

  const swiper = new Swiper('.reviews-section__swiper', {
    slidesPerView: 1.2,
    spaceBetween: 25,
    watchOverflow: true,
    breakpoints: {
      1200: {
        slidesPerView: 4
      },
      900: {
        slidesPerView: 3.2
      },
      500: {
        slidesPerView: 2.2
      },
      400: {
        slidesPerView: 1.4
      }
    }
  });

  function updateSlides() {
    swiper.removeAllSlides();

    for (let i = 0; i < slideCount; i++) {

      let slideAuthor = '';
      if(slideData[currentSlideIndex].name && slideData[currentSlideIndex].name.length > 0) {
        slideAuthor = `
        <em data-aos="grow-review" data-aos-duration="2500">
          <div class="line"></div>
          ${slideData[currentSlideIndex].name}
        </em>`;
      }

      let slideHtml = `
      <div class="swiper-slide">
        ${slideData[currentSlideIndex].image}
        <h3>${slideData[currentSlideIndex].title}</h3>        
        <p>${slideData[currentSlideIndex].text}</p>
        ${slideAuthor}
      </div>`;

      swiper.appendSlide(slideHtml);
      currentSlideIndex = (currentSlideIndex + 1) % slideData.length;
    }

    localStorage.setItem('currentSlideIndex', currentSlideIndex.toString());
    AOS.refreshHard();
    swiper.update();
  }

  updateSlides();
});

window.addEventListener('beforeunload', (event) => {
  let currentSlideIndex = localStorage.getItem('currentSlideIndex')
    ? parseInt(localStorage.getItem('currentSlideIndex'))
    : 0;
  localStorage.setItem('currentSlideIndex', currentSlideIndex.toString());
});